(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crosssell-pack"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function CrossSellPack(container) {
    this.container  = container;
    this.btn        = container.querySelector('[data-crosssell-add]');
    this.feedback   = container.querySelector('.crosssell-pack__feedback');
    this.btnText    = container.querySelector('.crosssell-pack__btn-text');
    this.btnSpinner = container.querySelector('.crosssell-pack__btn-spinner');
    this.variant1   = container.dataset.variant1;
    this.variant2   = container.dataset.variant2;

    if (this.btn) {
      this.btn.addEventListener('click', this._onAdd.bind(this));
    }
  }

  CrossSellPack.prototype._onAdd = function () {
    var self = this;
    self._setLoading(true);
    self._hideFeedback();

    var items = [
      { id: self.variant1, quantity: 1 },
      { id: self.variant2, quantity: 1 }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) { throw new Error(data.description || 'Erreur ajout panier'); });
      }
      return res.json();
    })
    .then(function () {
      self._showFeedback(
        document.querySelector('[data-crosssell-success]')
          ? document.querySelector('[data-crosssell-success]').textContent
          : '✓ Produits ajoutés au panier !',
        'success'
      );
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Mise à jour mini-cart si le thème le supporte
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        });
    })
    .catch(function (err) {
      self._showFeedback(err.message || 'Une erreur est survenue.', 'error');
    })
    .finally(function () {
      self._setLoading(false);
    });
  };

  CrossSellPack.prototype._setLoading = function (state) {
    this.btn.disabled = state;
    this.btnText.style.display    = state ? 'none' : '';
    this.btnSpinner.style.display = state ? '' : 'none';
  };

  CrossSellPack.prototype._showFeedback = function (msg, type) {
    this.feedback.textContent = msg;
    this.feedback.className = 'crosssell-pack__feedback crosssell-pack__feedback--' + type;
    this.feedback.style.display = '';
    var self = this;
    clearTimeout(self._feedbackTimer);
    self._feedbackTimer = setTimeout(function () { self._hideFeedback(); }, 4000);
  };

  CrossSellPack.prototype._hideFeedback = function () {
    this.feedback.style.display = '';
    this.feedback.textContent = '';
    this.feedback.style.display = 'none';
  };

  // Init tous les blocs sur la page
  function initAll() {
    document.querySelectorAll('[id^="crosssell-pack-"]').forEach(function (el) {
      if (!el.dataset.cpInit) {
        el.dataset.cpInit = '1';
        new CrossSellPack(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
